module.exports = __webpack_public_path__ + "img/giropay.5dc3da4b.svg";